//******************************************************************************
// 背景色に対して文字を白にするか黒にするか決める
/*
	// 使用例
	let backgroundColor = { r: 100, g: 150, b: 200 }; // RGB値
	let textColor = getContrastColor(backgroundColor.r, backgroundColor.g, backgroundColor.b);
	console.log(`推奨文字色: ${textColor}`);
*/

//******************************************************************************
/**
 * 正規化とガンマ補正
 * @param {number} value
 * @returns {number}
 */
function luminanceComponent(value) {
	let normalized = value / 255;
	return normalized <= 0.04045
		? normalized / 12.92
		: Math.pow((normalized + 0.055) / 1.055, 2.4);
}

//******************************************************************************
/**
 * export function
 * @param {number} r
 * @param {number} g
 * @param {number} b
 * @returns {"black"|"white"}
 */
export function getContrastColor(r, g, b) {
	// 線形輝度の計算
	const L = 0.2126 * luminanceComponent(r)
		+ 0.7152 * luminanceComponent(g)
		+ 0.0722 * luminanceComponent(b);
	// コントラスト比を計算
	// 白文字とのコントラスト
	const contrastWhite = (1.0 + 0.05) / (L + 0.05);
	// 黒文字とのコントラスト
	const contrastBlack = (L + 0.05) / (0.0 + 0.05);
	// 結果を返す
	return contrastWhite > contrastBlack ? "white" : "black";
}
